import {Component, HostBinding, OnDestroy} from '@angular/core';
import {routerFlipTransition} from '../../core/animations/router.animations';
import {RouterHelper} from '../../core/utilities/router-helper';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { NgIf } from '@angular/common';

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

@Component({
    selector: 'app-login',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    animations: [routerFlipTransition()],
    standalone: true,
    imports: [NgIf, RouterLink]
})
export class AuthErrorComponent implements OnDestroy {

  @HostBinding('@routerTransition') routerTransition = '';

  loginUrl: string;
  serverError: boolean;
  serverMessage: string;

  private paramsSubscription;

  constructor(private route: ActivatedRoute) {
    const module = RouterHelper.getRouteByComponent('LoginComponent');
    this.loginUrl = module.path;

    this.paramsSubscription = this.route.params.subscribe(params => {
      this.serverMessage = params['message']; // --> Name must match wanted parameter
      this.serverError = !!this.serverMessage;
    });
  }

  ngOnDestroy() {
    this.paramsSubscription?.unsubscribe();
  }
}
